// ============================================================
// Contact Form
// General-purpose contact/feedback entry point, reachable from
// anywhere in the app (landing page footer link, etc.) — not
// gated behind completing a paid report.
// ============================================================

import React, { useState } from 'react';
import { submitContact } from '../services/api';

const CATEGORIES = [
  'Payment issue',
  'General feedback',
  'Question about the assessment',
  'Consulting inquiry',
  'Other'
];

function ContactForm({ onBack }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [category, setCategory] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    if (!name || !email || !category || !message) {
      setError('Please fill in all fields.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const result = await submitContact(name, email, category, message);
      if (result.success) {
        setSubmitted(true);
      } else {
        setError(result.error || 'Could not send your message. Please try again.');
      }
    } catch (err) {
      setError('Could not send your message. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  if (submitted) {
    return (
      <div className="policy-page">
        <button className="link-button" onClick={onBack}>← Back</button>
        <div className="contact-thanks">Thank you — your message has been sent. We'll get back to you soon.</div>
      </div>
    );
  }

  return (
    <div className="policy-page">
      <button className="link-button" onClick={onBack}>← Back</button>
      <h1>Contact Us</h1>
      <p className="policy-updated">Have a question, a payment issue, feedback, or a consulting inquiry? Send us a message below.</p>

      <form onSubmit={handleSubmit}>
        <label className="field">
          Your Name
          <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Your full name" />
        </label>

        <label className="field">
          Your Email
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" />
        </label>

        <label className="field">
          What's this about?
          <select value={category} onChange={e => setCategory(e.target.value)}>
            <option value="">Select a category...</option>
            {CATEGORIES.map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </label>

        <label className="field">
          Your Message
          <textarea
            value={message}
            onChange={e => setMessage(e.target.value)}
            placeholder="Tell us what's on your mind..."
            rows="5"
          />
        </label>

        {error && <p className="error">{error}</p>}

        <button type="submit" className="btn-primary" disabled={loading}>
          {loading ? 'Sending...' : 'Send Message'}
        </button>
      </form>
    </div>
  );
}

export default ContactForm;
